module.exports = __webpack_public_path__ + "static/media/star-runner-screenshot-2.23c79236.jpg";